import React from "react";
import { useTheme } from "./ThemeContext";
import { DropdownButton, Dropdown } from "react-bootstrap";

const AppraisalDropdown = ({ appraisal, selectedValue, formatDate, onSelect }) => {
  const { isDark } = useTheme();

  return (
    <DropdownButton
      title={selectedValue || "Select Appraisal"}
      onSelect={onSelect}
      variant={isDark ? "dark" : "light"}
      size="sm"
      className={isDark ? "dropdown-dark" : ""}
    >
      {Array.isArray(appraisal) && appraisal.length > 0 ? (
        appraisal.map((a) => {
            const validStart = a.start_date && a.start_date !== "0000-00-00";
            const validDue = a.due_date && a.due_date !== "0000-00-00";

            const displayText =
              validStart && validDue
                ? `${a.appraisal_name} (${formatDate(a.start_date)} - ${formatDate(a.due_date)})`
                : a.appraisal_name; // show name only if dates are missing

            return (
              <Dropdown.Item
                key={a.appraisal_id}
                eventKey={a.appraisal_id}
                style={{
                  backgroundColor: isDark ? "#2c3e50" : "#fff",
                  color: isDark ? "#fff" : "#000",
                }}
              >
                {displayText}
              </Dropdown.Item>
            );
          })
      ) : (
        <Dropdown.Item disabled className={isDark ? "text-light bg-dark" : ""}>
          No Appraisal available
        </Dropdown.Item>
      )}
    </DropdownButton>
  );
};

export default AppraisalDropdown;
